import { gql } from '@apollo/client';

export const GET_REPORT_SUBMISSIONS = gql`
  query GET_REPORT_SUBMISSIONS($ids: [ID!], $projectIds: [ID!]) {
    reportSubmissions(ids: $ids, projectIds: $projectIds) {
      id
      reportType
      scheduledSubmissionDate
      reportingPeriod
      status
      actualSubmissionDate
      remarks
    }
  }
`;

export const GET_REPORT_SUBMISSION = gql`
  query GET_REPORT_SUBMISSION($ids: [ID!], $projectIds: [ID!]) {
    reportSubmissions(ids: $ids, projectIds: $projectIds) {
      id
      status
    }
  }
`;

export const GET_REPORT_SUBMISSION_DETAIL = gql`
  query GET_REPORT_SUBMISSION_DETAIL($ids: [ID!], $projectIds: [ID!]) {
    reportSubmissions(ids: $ids, projectIds: $projectIds) {
      id
      reportType
      status
      scheduledSubmissionDate
      reportingPeriod
      status
      reportFile {
        id
        filename
      }
      actualSubmissionDate
      remarks
    }
  }
`;

export const GET_REPORT_SUBMISSION_FORM_DETAIL = gql`
  query GET_REPORT_SUBMISSION_FORM_DETAIL($ids: [ID!], $projectIds: [ID!]) {
    reportSubmissions(ids: $ids, projectIds: $projectIds) {
      id
      isCurrentAppointedReviewer
      formDetail {
        reportForm
        sequence
        sections {
          sequence
          name
          appointedReviewer {
            user {
              id
              name
              netId
            }
            role {
              id
              name
            }
            reportControlType
            department {
              id
              name
              abbreviation
            }
            faculty {
              id
              name
              abbreviation
            }
          }
          completedBy {
            id
            netId
            name
            # department {
            #   id
            #   name
            #   faculty {
            #     id
            #     name
            #   }
            # }
          }
          date
          detail {
            question
            questionText
            questionType
            mandatory
            options {
              value
              label
            }
            answer
          }
        }
      }
    }
  }
`;

export const ADD_SCHEDULED_REPORT_SUBMISSION = gql`
  mutation ADD_SCHEDULED_REPORT_SUBMISSION(
    $input: AddScheduledReportSubmissionInput!
  ) {
    addScheduledReportSubmission(input: $input) {
      id
      status
    }
  }
`;

export const UPDATE_SCHEDULED_REPORT_SUBMISSION = gql`
  mutation UPDATE_SCHEDULED_REPORT_SUBMISSION(
    $input: UpdateScheduledReportSubmissionInput!
  ) {
    updateScheduledReportSubmission(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_SCHEDULED_REPORT_SUBMISSION = gql`
  mutation DELETE_SCHEDULED_REPORT_SUBMISSION(
    $input: DeleteScheduledReportSubmissionInput!
  ) {
    deleteScheduledReportSubmission(input: $input) {
      id
    }
  }
`;

export const SUBMIT_REPORT = gql`
  mutation SUBMIT_REPORT($input: SubmitReportInput!) {
    submitReport: submitReport(input: $input) {
      id
      status
    }
  }
`;

export const SUBMIT_REPORT_WITH_CUSTOM_DATE = gql`
  mutation SUBMIT_REPORT_WITH_CUSTOM_DATE(
    $input: SubmitReportWithCustomDateInput!
  ) {
    submitReport: submitReportWithCustomDate(input: $input) {
      id
      status
    }
  }
`;

export const SUBMIT_REPORT_REVIEW = gql`
  mutation SUBMIT_REPORT_REVIEW($input: SubmitReportReviewInput!) {
    submitReportReview(input: $input) {
      id
    }
  }
`;
